import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { LOCAL_STORAGE } from '@modules/local-storage/local-storage';

@Injectable()
export class LocalStorageService {

  constructor(
    @Inject(PLATFORM_ID) private platformId,
    @Inject(LOCAL_STORAGE) private localStorage,
  ) { }

  setItem(key: string, value: string) {
    if (this.isLocalStorageAvailable) {
      this.localStorage.setItem(key, value);
    }
  }

  getItem(key: string): string {
    if (this.isLocalStorageAvailable) {
      return this.localStorage.getItem(key);
    }
  }

  removeItem(key: string) {
    if (this.isLocalStorageAvailable) {
      this.localStorage.removeItem(key);
    }
  }

  get isLocalStorageAvailable() {
    return !!this.localStorage;
  }
}



// WEBPACK FOOTER //
// ./src/modules/local-storage/local-storage.service.ts